import { FC, useState } from 'react'

import { Space } from '@tribeplatform/gql-client/types'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { SpacePicker } from '../EntityPicker/SpacePicker.js'
import { T, useI18n } from '../i18n/index.js'

import { useUserImportContext } from './UserImportContext.js'

export interface SpaceMultipleAutocompleteProps {
  onChange: (values: Space[]) => void
  value: Space[]
}

export const SpaceMultipleAutocomplete: FC<
  SpaceMultipleAutocompleteProps
> = props => {
  const { $t, formatList } = useI18n()
  const { onChange, value = [] } = props
  const context = useUserImportContext()

  const [customSelect, setCustomSelect] = useState(false)

  return (
    <>
      {customSelect && (
        <SpacePicker
          onChange={onChange}
          value={value}
          placeholder={$t({
            defaultMessage: 'Search {SPACES}',
            id: 'Generics.SearchSpaces',
          })}
          multiple
        />
      )}
      {!customSelect && (
        <div className="text-sm flex space-s-2 text-content-subdued">
          {value?.length > 0 && (
            <Text>
              <T
                defaultMessage="Newly invited members will automatically join {spaces}"
                id="UserImport.AutoJoinSpaceList"
                values={{
                  spaces: formatList(
                    value.map(it => (
                      <span className="font-semibold break-all" key={it.id}>
                        {it.name}
                      </span>
                    )),
                    { type: 'conjunction' },
                  ),
                }}
              />
            </Text>
          )}
          {context?.hasInviteDefaultsPermission && (
            <Link
              as="button"
              type="button"
              onClick={() => setCustomSelect(true)}
              data-testid="spaces-edit"
            >
              <T defaultMessage="Edit" id="Generics.Edit" />
            </Link>
          )}
        </div>
      )}
    </>
  )
}
